import React, {useEffect, useState} from 'react';
import {user_data} from "../../../../../../../../components/functions/usr";
import axios from "axios";
import {addFunc, bolFunc, fixIt} from "../../../../../../../../components/functions/Mathematik";
import {header} from "../../../../../../../../components/api/Header";
import {gmslar, season_month} from "../../../../../../../../components/sfr/maydon";
import Info from "./Info";
import { getEnv } from "../../../../../../../../lib/env";

function Xisobot7(props) {
    const year = localStorage.getItem('sfr-hm-year')
    const user = user_data()
    const season = localStorage.getItem('sfr-hm-season')
    const [maydonlar, setMaydonlar] = useState({})
    const sfrMaydon = localStorage.getItem("sfr-hm-"+season+"-maydon")
    const sfrMaydonlar = sfrMaydon?JSON.parse(sfrMaydon):{}
    const ekin = localStorage.getItem("sfr-hm-"+season+"-ekinlar")
    const ekinlar = ekin?JSON.parse(ekin):{}
    const [swed, setSwed] = useState({})
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const istemolchilar = ist?JSON.parse(ist):[]
    const crops1 = localStorage.getItem('sfr-hm-'+season+'-ekinids')
    let cropids = crops1?JSON.parse(crops1):[]
    const may = localStorage.getItem("sfr-hm-"+season+"-maydon")
    const maydon = may?JSON.parse(may):[]
    useEffect(()=>{
        let gmss = []
        const fetchSwed = async (gmss,gmss2) => {
            const postData = {
                crops:cropids,
                gmss,
                maydonlar:gmss2,
                tomorqa1:true
            }
            const res = await axios.post(
                getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/veg_sugorish_meyyori3",
                postData,
                header(),
            )
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setSwed(res.data)
            }
        }
        const maydons = () => {
            let gidromodullar = []
            istemolchilar.map(i=>{
                if(i.gms){
                    i.gms.map(g=>{
                        if(!gidromodullar.includes(g)){
                            gidromodullar.push(g)
                        }
                    })
                }
            })
            gmss = gidromodullar
        }
        maydons()
        const gmss2 = gmslar(maydon,cropids)
        setMaydonlar(gmss2)
        if(gmss2)
            fetchSwed(gmss,gmss2)
    },[])

    const ff = (ist) => {
        if(!ist.gms) return 0
        if(!ist.gms.length) return 0
        let res = {}
        let ee = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        let jeb = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        Object.keys(ekinlar).map(e=>{
            ee = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
            for(let deks = 1; deks < 19; deks++){
                if(swed[e.slice(1)]){
                    ist.gms.map(gms2=>{
                        if(swed[e.slice(1)][gms2]){
                            let jm = maydonlar['g'+gms2]?maydonlar['g'+gms2][e]:0
                            let im = sfrMaydonlar['i'+ist.id]?sfrMaydonlar['i'+ist.id]['g'+gms2]?sfrMaydonlar['i'+ist.id]['g'+gms2][e]:0:0
                            let ds = swed[e.slice(1)][gms2][deks]
                            ee[deks-1] = addFunc(ee[deks-1],(bolFunc(im,jm)*ds))
                        }
                    })
                }
                jeb[deks-1] = addFunc(jeb[deks-1],ee[deks-1])
            }
            res[e] = ee
        })
        res['jami'] = jeb
        return res
    }
    const xisobot = () => {
        let obj = [];
        if(istemolchilar.length){
            cropids = cropids?cropids.filter(ci=>ci!=19):[]
            istemolchilar.map((istemolchi,i)=>{
                let job = 0
                let ms = ff(istemolchi)
                obj.push(
                    <tr key={i+"a"}>
                        <td rowSpan={cropids.length*2+3} style={{verticalAlign:"baseline",position:"relative"}}>
                            <span style={{position:"sticky",top:"100px"}}>
                                {i+1}
                            </span>
                        </td>
                        <td rowSpan={cropids.length*2+3} style={{verticalAlign:"baseline", maxWidth:"100px",position:"relative"}}>
                            <span style={{position:"sticky",top:"100px"}}>
                                {istemolchi.name}
                            </span>
                        </td>
                        <td rowSpan={2} className="text-start ps-2">Jami</td>
                        <td className="text-start ps-2">Dekada</td>
                        {
                            ms['jami']?
                                ms['jami'].map((jd,jindex)=>{
                                    return <td key={i+'j'+jindex}>{jd?fixIt(jd,1):''}</td>
                                })
                                :null
                        }
                    </tr>
                )
                obj.push(
                    <tr key={i+'b'}>
                        <td className="text-start ps-2">O'sib borishi</td>
                        {
                            ms['jami']?
                                ms['jami'].map((jd,jindex)=>{
                                    job = addFunc(job,jd)
                                    return <td key={i+'j'+jindex}>{job?fixIt(job,1):''}</td>
                                })
                                :null
                        }
                    </tr>
                )
                obj.push(
                    <tr key={i+'c'}>
                        <td colSpan={2} className="text-start ps-2">Shu jumladan</td>
                    </tr>
                )
                cropids.map((cid,cindex)=>{
                    let ob = 0
                    obj.push(
                        <tr key={i+'d'+cindex}>
                            <td rowSpan={2} className="text-start ps-2" style={{maxWidth:"100px"}}>{ekinlar['e'+cid].name}</td>
                            <td className="text-start ps-2">Dekadalik</td>
                            {
                                ms['e'+cid]?
                                    ms['e'+cid].map((ed,eindex)=>{
                                        return <td key={i+'d'+cid+'e'+eindex}>{ed?fixIt(ed,1):''}</td>
                                    })
                                    :null
                            }
                        </tr>
                    )
                    obj.push(
                        <tr key={i+'ob'+cindex}>
                            <td className="text-start ps-2">O'sib boruvchi</td>
                            {
                                ms['e'+cid]?
                                    ms['e'+cid].map((ed,eindex)=>{
                                        ob = addFunc(ob,ed)
                                        return <td key={i+'o'+cid+'b'+eindex}>{ob?fixIt(ob,1):''}</td>
                                    })
                                    :null
                            }
                        </tr>
                    )
                })

            })
        }
        return obj;
    }


    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-borderless m-0">
                    <thead>
                    <tr>
                        <td><h4 className="text-center">Xisobot - №4</h4></td>
                    </tr>
                    <tr>
                        <td>
                            <h5 className="text-center px-5">{user.district}ning {year} yil sug'orish davrida sug'orish ishlari JADVALI (keltirilgan maydon)</h5>
                        </td>
                    </tr>
                    </thead>
                </table>
                <div className="text-end pe-3">gektar</div>
                <div className="flex-box xisobot-table">
                    <div className="xisobotTable">
                        <table className="table table-bordered text-center xisobot3">
                            <thead className="sticky-top" style={{background:"#77adba",color:"#fff"}}>
                            <tr>
                                <th rowSpan={2}>No</th>
                                <th rowSpan={2}>Suv istemolchilari</th>
                                <th rowSpan={2} colSpan={2}>Ko'rsatgichlar</th>
                                {
                                    season_month(season).map((m,i)=>{
                                        return <th key={i} colSpan={3}>{m}</th>
                                    })
                                }
                            </tr>
                            <tr>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                            </tr>
                            </thead>
                            <tbody>
                            {xisobot()}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-2">
                <Info />
            </div>
        </div>
    );
}

export default Xisobot7;